import { BILLING_RUN_DOCUMENT_ATTACHMENTS } from "constants/actionTypes";

import { offlineActionCreator } from "./lib";
import { billingRunUrlCreator } from "./billingRuns";

const billingRunDocumentAttachmentsUrlCreator = ({
  changesSince,
  id,
  userRole,
}) => {
  return billingRunUrlCreator({
    action: "billing-documents-related-attachments",
    changesSince,
    id,
    userRole,
  });
};

export const deserializeBillingDocumentAttachmentIds = payload => ({
  id: payload.id,
  attachmentIds: payload.attachment_ids || [],
});

export const billingRunDocumentAttachmentsAction = offlineActionCreator(
  BILLING_RUN_DOCUMENT_ATTACHMENTS,
  deserializeBillingDocumentAttachmentIds,
  billingRunDocumentAttachmentsUrlCreator,
  false,
);
